import { render, staticRenderFns } from "./OpportunityManagementModal.vue?vue&type=template&id=5ddb258f"
import script from "./OpportunityManagementModal.vue?vue&type=script&lang=js"
export * from "./OpportunityManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports